import {
  STATUS_TOAST_DURATION_MS,
  STATUS_TOAST_MAX_DURATION_MS,
  STATUS_TOAST_MS_PER_EXTRA_CHAR,
  STATUS_TOAST_SHORT_MESSAGE_CHARS,
} from '../constants/statusToast';

export function resolveStatusToastDuration(
  visibleTexts: ReadonlyArray<string | undefined>,
): number {
  const totalChars = visibleTexts.reduce(
    (sum, text) => sum + (text?.length ?? 0),
    0,
  );
  const extraChars = Math.max(0, totalChars - STATUS_TOAST_SHORT_MESSAGE_CHARS);
  return Math.min(
    STATUS_TOAST_DURATION_MS + extraChars * STATUS_TOAST_MS_PER_EXTRA_CHAR,
    STATUS_TOAST_MAX_DURATION_MS,
  );
}
